module.exports = __webpack_public_path__ + "static/media/logo.6825c8a5.png";